document.documentElement.classList.add('js');
const initWatersports = () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const navigation = document.getElementById('MainNavigation');
  toggle?.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(expanded));
    navigation?.classList.toggle('is-open', expanded);
  });
  const desktop = matchMedia('(min-width: 801px)');
  desktop.addEventListener('change', () => {
    toggle?.setAttribute('aria-expanded', 'false');
    navigation?.classList.remove('is-open');
  });
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.dialogOpen);
      if (dialog instanceof HTMLDialogElement) {
        dialog._opener = opener;
        document.querySelectorAll('.mega-nav[open]').forEach(menu => { menu.open = false; });
        dialog.showModal();
      }
    }
    if (event.target.closest('[data-dialog-close]')) event.target.closest('dialog')?.close();
    document.querySelectorAll('.mega-nav[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rectangle = dialog.getBoundingClientRect();
      if (event.clientX < rectangle.left || event.clientX > rectangle.right || event.clientY < rectangle.top || event.clientY > rectangle.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => dialog._opener?.focus());
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mega-nav[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
    if (!document.querySelector('dialog[open]') && navigation?.classList.contains('is-open')) {
      navigation.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
      toggle?.focus();
    }
  });
  const finder = document.querySelector('[data-gear-finder]');
  finder?.addEventListener('submit', event => {
    event.preventDefault();
    const sport = finder.querySelector('[name=sport]');
    const experience = finder.querySelector('[name=experience]');
    const result = document.querySelector('[data-finder-result]');
    if (!sport?.value || !result) return;
    document.querySelector('[data-finder-link]').href = sport.value;
    result.querySelectorAll('[data-experience]').forEach(paragraph => { paragraph.hidden = paragraph.dataset.experience !== experience.value; });
    result.hidden = false;
    result.focus();
  });
  const checklist = [...document.querySelectorAll('[data-checklist-item]')];
  const storageKey = 'watersports-supply-day-checklist-v1';
  let storageAvailable = true;
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(saved)) checklist.forEach(input => { input.checked = saved.includes(input.dataset.checklistItem); });
  } catch { storageAvailable = false; }
  const updateChecklist = (persist = false) => {
    const values = checklist.filter(input => input.checked).map(input => input.dataset.checklistItem);
    const progress = document.querySelector('[data-checklist-progress]');
    const count = document.querySelector('[data-checklist-count]');
    if (progress) { progress.max = checklist.length; progress.value = values.length; }
    if (count) count.textContent = `${values.length} / ${checklist.length}`;
    if (persist) {
      try { localStorage.setItem(storageKey, JSON.stringify(values)); }
      catch { storageAvailable = false; }
    }
    if (!storageAvailable) {
      const status = document.querySelector('[data-checklist-status]');
      if (status) status.textContent = status.dataset.storageError;
    }
  };
  checklist.forEach(input => input.addEventListener('change', () => updateChecklist(true)));
  document.querySelector('[data-checklist-reset]')?.addEventListener('click', () => {
    checklist.forEach(input => { input.checked = false; });
    updateChecklist(true);
  });
  updateChecklist();
  document.querySelectorAll('[data-variant-select]').forEach(select => {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const button = select.form.querySelector('[data-add-button]');
      const price = select.closest('.product-information').querySelector('[data-product-price]');
      if (price) price.textContent = option.dataset.price;
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? `${button.dataset.addLabel} ↗` : button.dataset.soldLabel;
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', select.value);
      history.replaceState({}, '', url);
    });
  });
  document.querySelectorAll('[data-copy-url]').forEach(button => {
    button.addEventListener('click', async () => {
      const status = document.querySelector('[data-copy-status]');
      try {
        await navigator.clipboard.writeText(location.href);
        if (status) status.textContent = button.dataset.copySuccess;
      } catch {
        if (status) status.textContent = button.dataset.copyError;
      }
    });
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initWatersports, { once: true });
else initWatersports();
const initReadingList = () => {
  const panel = document.querySelector('[data-reading-list]');
  if (!panel) return;
  const key = 'watersports-supply-reading-list-v1';
  let stories = [];
  let canSave = true;
  const validStory = story => {
    if (!story || typeof story.id !== 'string' || typeof story.title !== 'string' || typeof story.url !== 'string') return false;
    try {
      const url = new URL(story.url, location.origin);
      return url.origin === location.origin && ['http:', 'https:'].includes(url.protocol);
    } catch { return false; }
  };
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      stories = Array.isArray(value) ? value.filter(validStory).slice(-250) : [];
    } catch { canSave = false; }
  };
  const announce = message => document.querySelectorAll('[data-reading-status]').forEach(status => { status.textContent = message; });
  const render = () => {
    document.querySelectorAll('[data-article-bookmark]').forEach(button => {
      const saved = stories.some(story => story.id === button.dataset.articleId);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', saved ? button.dataset.savedAria : button.dataset.saveAria);
      button.querySelector('[data-bookmark-label]').textContent = saved ? button.dataset.savedLabel : button.dataset.saveLabel;
    });
    document.querySelectorAll('[data-reading-count]').forEach(count => { count.textContent = String(stories.length); });
    const list = panel.querySelector('[data-reading-items]');
    list.replaceChildren();
    stories.forEach(story => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = story.url;
      link.textContent = story.title;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.readingRemove = story.id;
      remove.textContent = panel.dataset.removeLabel;
      remove.setAttribute('aria-label', `${panel.dataset.removeLabel}: ${story.title}`);
      item.append(link, remove);
      list.append(item);
    });
    panel.querySelector('[data-reading-empty]').hidden = stories.length > 0;
  };
  const persist = notice => {
    try { localStorage.setItem(key, JSON.stringify(stories)); canSave = true; }
    catch { canSave = false; }
    render();
    announce(canSave ? notice : panel.dataset.storageError);
  };
  read();
  render();
  if (!canSave) announce(panel.dataset.storageError);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-article-bookmark]');
    if (button) {
      const index = stories.findIndex(story => story.id === button.dataset.articleId);
      if (index >= 0) {
        stories.splice(index, 1);
        persist(panel.dataset.removeNotice);
      } else {
        const story = { id: button.dataset.articleId, title: button.dataset.articleTitle, url: button.dataset.articleUrl };
        if (validStory(story)) {
          stories.push(story);
          stories = stories.slice(-250);
          persist(panel.dataset.saveNotice);
        }
      }
    }
    const remove = event.target.closest('[data-reading-remove]');
    if (remove) {
      const index = stories.findIndex(story => story.id === remove.dataset.readingRemove);
      stories = stories.filter(story => story.id !== remove.dataset.readingRemove);
      persist(panel.dataset.removeNotice);
      const remaining = panel.querySelectorAll('[data-reading-remove]');
      if (remaining.length) remaining[Math.min(index, remaining.length - 1)].focus();
      else panel.querySelector('[data-dialog-close]').focus();
    }
  });
  window.addEventListener('storage', event => {
    if (event.key === key) { read(); render(); }
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReadingList, { once: true });
else initReadingList();
